import { Field } from '../PreviewFields';
import { PreviewHeader } from '../PreviewHeader';

export interface RationCardFormValues {
  RationCardNumber: string;
  AadhaarNumber: string;
}

export interface RationCardScreenProps {
  /** Live form values — pass from the session runtime; omit in the builder mock. */
  values?: RationCardFormValues;
  onChange?: (patch: Partial<RationCardFormValues>) => void;
  errors?: Partial<Record<keyof RationCardFormValues, string>>;
  /** Method display name ("Ration Card Verification") — shown for consistency. */
  method?: string;
}

// Ration Card Verification — the applicant enters their ration card number (or,
// optionally, the linked Aadhaar number); the provider returns the card + household
// details. Single method (Protean). OWN interim design — swap for the designer's
// screen when it arrives.
export function RationCardScreen({ values, onChange, errors }: RationCardScreenProps) {
  return (
    <>
      <PreviewHeader title="Ration Card Verification" subtitle="Enter your ration card details" />
      <Field
        label="Aadhaar Number"
        placeholder="6179XXXXXXXX"
        inputMode="numeric"
        hint="12-digit Aadhaar number linked to the ration card"
        value={values?.AadhaarNumber}
        onChange={onChange ? (v) => onChange({ AadhaarNumber: v }) : undefined}
        error={errors?.AadhaarNumber}
      />
      <Field
        label="Ration Card Number"
        placeholder="6112XXXX"
        hint="Your ration card number"
        value={values?.RationCardNumber}
        onChange={onChange ? (v) => onChange({ RationCardNumber: v }) : undefined}
        error={errors?.RationCardNumber}
      />
      <p className="mt-2 text-[14px] leading-tight text-[#666666]">
        Both your Aadhaar and ration card number are required to look up the linked ration card. We
        verify them securely and do not store data beyond what is required by law.
      </p>
    </>
  );
}
